import { render } from "./ViewProducts.vue?vue&type=template&id=f5bb31d2"
import script from "./ViewProducts.vue?vue&type=script&lang=js"
export * from "./ViewProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__